<template>
<DictTable :pid="dictId" module-name="港口" dictType="harbour"></DictTable>
</template>

<script>
import DictTable from '@/components/dict/dict-table.vue'
export default {
  name: 'harbour',
  components:{DictTable},
  data(){
    return {
      dictId:'1714194190595424257'
    }
  }
}
</script>

<style scoped>

</style>
